var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3 17.2L19 14.5M19 14.5L16.3 11.8M19 14.5H13.6M10 12.25H5.95C4.69399 12.25 4.06599 12.25 3.55497 12.405C2.40441 12.754 1.50404 13.6544 1.15502 14.805C1 15.316 1 15.944 1 17.2M12.25 5.05C12.25 7.28675 10.4368 9.1 8.2 9.1C5.96325 9.1 4.15 7.28675 4.15 5.05C4.15 2.81325 5.96325 1 8.2 1C10.4368 1 12.25 2.81325 12.25 5.05Z",
    stroke: "#118F84",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.fd4b8bf826d48034e1d7f9fa0856b92b.svg";
export { ForwardRef as ReactComponent };